import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStopwatch = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M16.0303 8.71967C16.3232 9.01256 16.3232 9.48744 16.0303 9.78033L13.6487 12.1619C13.7143 12.3457 13.75 12.5437 13.75 12.75C13.75 13.7165 12.9665 14.5 12 14.5C11.0335 14.5 10.25 13.7165 10.25 12.75C10.25 11.7835 11.0335 11 12 11C12.2063 11 12.4043 11.0357 12.5881 11.1013L14.9697 8.71967C15.2626 8.42678 15.7374 8.42678 16.0303 8.71967Z",
		fill: "var(--colors-grey-1)"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.25 0C9.83579 0 9.5 0.335786 9.5 0.75C9.5 1.16421 9.83579 1.5 10.25 1.5H11.25V2.7777C9.11504 2.936 7.16664 3.76462 5.61451 5.05385L4.28033 3.71967C3.98744 3.42678 3.51256 3.42678 3.21967 3.71967C2.92678 4.01256 2.92678 4.48744 3.21967 4.78033L4.53516 6.09582C2.95832 7.8635 2 10.1948 2 12.75C2 18.2728 6.47715 22.75 12 22.75C17.5228 22.75 22 18.2728 22 12.75C22 10.1948 21.0417 7.86351 19.4648 6.09582L20.7803 4.78033C21.0732 4.48744 21.0732 4.01256 20.7803 3.71967C20.4874 3.42678 20.0126 3.42678 19.7197 3.71967L18.3855 5.05385C16.8334 3.76462 14.885 2.936 12.75 2.7777V1.5H13.75C14.1642 1.5 14.5 1.16421 14.5 0.75C14.5 0.335786 14.1642 0 13.75 0H10.25ZM12 21.25C16.6944 21.25 20.5 17.4444 20.5 12.75C20.5 8.05558 16.6944 4.25 12 4.25C7.30558 4.25 3.5 8.05558 3.5 12.75C3.5 17.4444 7.30558 21.25 12 21.25Z",
		fill: "var(--colors-grey-1)"
	})]
});
export default SvgStopwatch;
